export interface AssistReason {
  label: string;
  value: 'driver_late';
  description: string;
  placeholder: string;
}

export type AssistButtonAction =
  | 'button'
  | 'help'
  | 'reason'
  | 'next'
  | 'complaint'
  | 'cancel'
  | 'solved'
  | 'close'
  | 'nothing';
export type AssistButtonDeferredAction = 'next' | 'cancel';

export interface AssistButton {
  label: string;
  context?: string;
  action: AssistButtonAction;
  deferred_action?: AssistButtonDeferredAction;
  type: 'main_default' | 'main_timer' | 'main_dot' | 'help' | 'submit' | 'blue' | 'white' | 'red';
  time?: number;
}

export interface AssistAdditionalAction {
  backAction?: AssistButtonAction;
}

export interface AssistContent {
  icon?: 'true' | 'false' | 'clock' | 'gear' | 'car' | 'face' | 'warring' | 'dsp_next';
  title?: string;
  subtitle?: string;
  reasons?: AssistReason[];
  buttons?: AssistButton[];
  additional?: AssistAdditionalAction;
}

export type AssistRenderType =
  | 'button'
  | 'popup_help'
  | 'popup_reason'
  | 'popup_icon'
  | 'close'
  | 'nothing'
  | 'spinner';

export interface AssistResponse {
  result: boolean;
  render_type: AssistRenderType;
  content: AssistContent;
  delivery_request_id?: number;
  // time_actions ???
}

export enum DataLoadingStatus {
  Initial = 'Initial',
  Loading = 'Loading',
  Failure = 'Failure',
  Loaded = 'Loaded',
}
